import { createContext, useContext } from 'react';

import type { CoachDelTavolo } from '@/lib/qgammon/useCoachQgammon';

/**
 * Il coach del tavolo attivo per chi sta SOTTO `ActiveMatchProvider` (`null` a flag spento, e fuori dal provider).
 * Sta in un contesto SUO, e non in `ActiveMatchContext`, per una ragione di banco: decine di test sostituiscono `@/contexts/ActiveMatchContext` con un doppio che
 * espone solo `useActiveBackgammonMatch`, e un hook nuovo li' dentro li romperebbe tutti. Qui il tipo di `CoachDelTavolo` e' solo un tipo: il modulo non porta nessun
 * marcatore del coach (nessuna stringa di evento, nessun testo) e in produzione il valore e' sempre `null`.
 */
export const CoachContext = createContext<CoachDelTavolo | null>(null);

export function useCoachDelTavolo(): CoachDelTavolo | null {
  return useContext(CoachContext);
}
